import { render } from "./block_video.vue?vue&type=template&id=b06b4594&scoped=true"
import script from "./block_video.vue?vue&type=script&lang=js"
export * from "./block_video.vue?vue&type=script&lang=js"

import "./block_video.vue?vue&type=style&index=0&id=b06b4594&scoped=true&lang=css"

import exportComponent from "/var/www/miqrositio/miqrositio_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b06b4594"]])

export default __exports__